module.exports = __webpack_public_path__ + "static/img/home_index4_icon6.a8523e12.png";